/**
 * @fileoverview App Review Provider
 * 
 * Globally mounts the review modal and checks eligibility.
 * Listens for app foreground events to trigger checks.
 */

import { useAppReviewPrompt } from '@/hooks/useAppReviewPrompt';
import { AppReviewModal } from '@/components/review/AppReviewModal';

export function AppReviewProvider() {
  const { shouldShow, settings, markDismissed, submitRating } = useAppReviewPrompt();

  return (
    <AppReviewModal
      open={shouldShow}
      title={settings?.prompt_title ?? 'Enjoying WNTD?'}
      subtitle={settings?.prompt_subtitle ?? 'Your review helps others discover us'}
      onDismiss={() => markDismissed()}
      onSubmit={submitRating}
    />
  );
}
